import { FC, memo, useMemo } from 'react'
import { Tooltip, CardProps, Heading, HStack, Center, Card } from '@chakra-ui/react'

import { useValidatePermissions } from 'hooks'
import getAssets from 'utils/assets/getAssets'

type Props = CardProps & {
  permissions?: (string | undefined)[]
  children?: string
}

const CardButtonWithPermission: FC<Props> = ({ permissions, children, ...cardProps }) => {
  const { validatePermissions } = useValidatePermissions()

  const CreateIcon = getAssets('Icon', 'Create')

  const hasPermission = useMemo(() => {
    return validatePermissions(permissions)
  }, [])

  return (
    <Tooltip isDisabled={hasPermission} label="Você não tem permissão">
      <Card
        height="100%"
        bg="primary"
        pointerEvents="unset"
        className={hasPermission ? 'accessible' : ''}
        tabIndex={hasPermission ? 0 : -1}
        opacity={hasPermission ? 1 : 0.5}
        filter={hasPermission ? 'grayscale(0)' : 'grayscale(1)'}
        cursor={hasPermission ? 'pointer' : 'not-allowed'}
        _hover={hasPermission ? { opacity: 0.8 } : {}}
        {...cardProps}
      >
        <HStack width="100%" height="100%" align="center" justify="center" spacing={4}>
          <Center rounded="full" height="50px" width="50px" bg="light">
            <CreateIcon boxSize="30px" color="primary" />
          </Center>
          <Heading textAlign="center" color="light">
            {children}
          </Heading>
        </HStack>
      </Card>
    </Tooltip>
  )
}

export default memo(CardButtonWithPermission)
